const initState = {
    isLoading: false,
    loaded: false,
    transactions: [],
    totalTran: 0,
    totalIncome: 0,
    totalTranAllStatus: 0,
};

const loadTranReducer = (state = initState, action) => {
    switch(action.type){
        case "LOAD":
            return{...state, loaded: false, isLoading: true, 
                transactions: [],
                totalTran: 0,
                totalIncome: 0,
                totalTranAllStatus: 0,
            };
        case "LOAD_SUCCESS":
            return{...state, loaded: true, isLoading: false, 
                transactions: Object.assign([], action.transactions),
                totalTran: action.totalTran,
                totalIncome: action.totalIncome,
                totalTranAllStatus: action.totalAllStatus,
            }
        case "LOAD_FAIL":
            return{...state, loaded: false, isLoading: false, 
                transactions: [],
                totalTran: 0,
                totalIncome: 0,
                totalTranAllStatus: 0,
            }
        default:
            return state;
    }
};

export default loadTranReducer;